module.exports = __webpack_public_path__ + "img/logo-bodecor.5ee5aff5.svg";